import React, { useCallback } from 'react';

import {
  ConditionsReactivateTypeAutoriteFourriereDto,
  ReferentielSearchResultDtoTypeAutoriteFourriereDto,
  TypeAutoriteFourriereDto,
  TypeAutoriteFourriereRequestDto,
} from 'lib_api/lib/api/gen';

import {
  FetchDataResult,
  TableHeaderFunctionWithoutSort,
} from 'components/WrappedComponents/Table/types';
import { useApi } from 'hooks/ApiStoreContext';
import { TypeAfFormValues } from 'types/referentiels/TypeAf';

import DashboardHeader from './DashboardHeader/DashboardHeader';
import { FilterDashboardTypeAf } from './types';

export const buildHeader: TableHeaderFunctionWithoutSort<
  TypeAutoriteFourriereDto,
  FilterDashboardTypeAf
> = (fetchedData, _selectedData, filter, setFilter) => (
  <DashboardHeader
    totalCount={fetchedData?.total ?? 0}
    filter={filter}
    setFilter={setFilter}
  />
);

export function useSearchTypeAf(
  filter: FilterDashboardTypeAf,
): [
  () => Promise<ReferentielSearchResultDtoTypeAutoriteFourriereDto>,
  (
    result: ReferentielSearchResultDtoTypeAutoriteFourriereDto,
  ) => FetchDataResult<TypeAutoriteFourriereDto>,
] {
  const controller = useApi().AdminFonctionnelControllerApi;

  return [
    () => {
      return controller.searchTypeAfUsingSpecsUsingGET({
        filters: {
          ...filter,
        },
      });
    },
    result => {
      return {
        data: result.results.referenceDtoList,
        total: result.total,
      };
    },
  ];
}

export function buildRequestDto(
  data: TypeAfFormValues,
): TypeAutoriteFourriereRequestDto {
  return {
    type: data.type?.trim() || null,
    displayedText: data.displayedText || null,
    codeTypologieNiveau1: data.codeTypologieNiveau1 || null,
    codeTypologieNiveau2: data.codeTypologieNiveau2 || null,
  };
}

export const buildFormValues = (
  typeAf: TypeAutoriteFourriereDto,
): TypeAfFormValues => {
  return {
    type: typeAf?.type ?? undefined,
    displayedText: typeAf?.displayedText ?? undefined,
    codeTypologieNiveau1: typeAf?.alienationCodeTypologieNiveau1 ?? undefined,
    codeTypologieNiveau2: typeAf?.alienationCodeTypologieNiveau2 ?? undefined,
  };
};

export function useChangeValidityTypeAf(): [
  (idCorrelation: string) => Promise<Response>,
  (idCorrelation: string) => Promise<Response>,
  (
    idCorrelation: string,
  ) => Promise<ConditionsReactivateTypeAutoriteFourriereDto>,
] {
  const controller = useApi().AdminFonctionnelControllerApi;

  const submitDeprecateReferentiel = useCallback(
    (idCorrelation: string): Promise<Response> => {
      return controller.deprecateTypeAfUsingPUT(idCorrelation);
    },
    [controller],
  );

  const submitReactivateReferentiel = useCallback(
    (idCorrelation: string): Promise<Response> => {
      return controller.reactivateTypeAfUsingPUT(idCorrelation);
    },
    [controller],
  );

  const conditionsReactivateReferentiel = useCallback(
    (
      idCorrelation: string,
    ): Promise<ConditionsReactivateTypeAutoriteFourriereDto> => {
      return controller.conditionReactivationTypeAfUsingGET(idCorrelation);
    },
    [controller],
  );

  return [
    submitReactivateReferentiel,
    submitDeprecateReferentiel,
    conditionsReactivateReferentiel,
  ];
}
